











import {Component, Vue, Inject} from 'vue-property-decorator';
import TokenErrorAlert from "./TokenErrorAlert.vue";
import CreateMediaWarningAlert from "@/components/alerts/CreateMediaWarningAlert.vue";
import CreateMediaErrorAlert from "@/components/alerts/CreateMediaErrorAlert.vue";
import CreateMediaSuccessAlert from "@/components/alerts/CreateMediaSuccessAlert.vue";
import CreateEventErrorAlert from "@/components/alerts/CreateEventErrorAlert.vue";
import CreateEventSuccessAlert from "@/components/alerts/CreateEventSuccessAlert.vue";

@Component({
  components: {
    CreateEventSuccessAlert,
    CreateEventErrorAlert,
    CreateMediaSuccessAlert,
    CreateMediaErrorAlert,
    CreateMediaWarningAlert,
    TokenErrorAlert
  }
})
export default class GeneralAlertComponent extends Vue {

}
